// From "Jetstar Cancellation Rules by Bundle (AU)" in Notion, checked against Jetstar's AU product
// guides and fees page on 28 Oct 2026. Sabre's LCC bookings carry no fare rules, so this is all the
// Refund Calculator has to go on for a Jetstar booking.

export interface JetstarCancellationRule {
  bundle: string
  canCancel: 'Yes' | 'No' | 'Unknown'
  getsBack: string
  fee: string
  cutoff: string
}

export const JETSTAR_CANCELLATION_RULES: readonly JetstarCancellationRule[] = [
  { bundle: 'Starter (base fare)', canCancel: 'No', getsBack: 'Nothing', fee: 'n/a', cutoff: 'n/a' },
  { bundle: 'Boost', canCancel: 'No', getsBack: 'Nothing', fee: 'n/a', cutoff: 'n/a' },
  { bundle: 'More', canCancel: 'No', getsBack: 'Nothing', fee: 'n/a', cutoff: 'n/a' },
  { bundle: 'Packed', canCancel: 'No', getsBack: 'Nothing', fee: 'n/a', cutoff: 'n/a' },
  { bundle: 'Starter Plus', canCancel: 'No', getsBack: 'Nothing', fee: 'n/a', cutoff: 'n/a' },
  {
    bundle: 'Flex',
    canCancel: 'Yes',
    getsBack: 'Credit voucher only (no cash)',
    fee: 'None stated',
    cutoff: 'Before the Change Deadline (economy: when airport check-in opens)',
  },
  {
    bundle: 'Flex Plus',
    canCancel: 'Yes',
    getsBack: 'Credit voucher only (no cash)',
    fee: 'None stated',
    cutoff: 'Before the Change Deadline',
  },
  {
    bundle: 'Business Max',
    canCancel: 'Yes',
    getsBack: 'Refund to original payment method, less fee',
    fee: 'AUD/NZD $50 per passenger per booking (FJD $75)',
    cutoff: 'Request by end of the original departure day, via the Contact Centre (Agent Hub)',
  },
  {
    bundle: 'Mini / Max / Business Class',
    canCancel: 'Unknown',
    getsBack: 'Unknown',
    fee: 'Unknown',
    cutoff: 'Unknown',
  },
]

export const JETSTAR_CANCELLATION_NOTES: readonly string[] = [
  'Non-refundable bundles can still be refunded under Australian Consumer Law and the Conditions of Carriage, e.g. when Jetstar cancels the flight.',
  'FareCredit (paid add-on) lets the customer cancel for any reason until airport check-in opens, for a voucher (3 years on JQ, 6 months on GK).',
  'Flex terms change for flights from 2 Feb 2027.',
]

export const JETSTAR_AGENT_HUB_MESSAGE =
  'Jetstar segments are required to be cancelled in Agent Hub. Please proceed to cancel or handover to CCM to action'

// JQ is the only LCC carrier PLT books through Sabre. The quote's fallback response carries no
// carrier, so a missing one is read as Jetstar rather than hiding its rules.
export const isJetstarLccBooking = ({ lccBooking, carrier }: { lccBooking?: boolean; carrier?: string }): boolean =>
  Boolean(lccBooking) && (!carrier || carrier.toUpperCase() === 'JQ')
